import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import './CashbackActivate.scss';
import Button from 'components/Button';

const b = block('cashback-activate-mobile');

const CashbackActivate = ({ closeFunction, callback }) => {
  const locale = useSelector(state => state.locale.locale);

  const handleActivate = () => {
    callback(closeFunction, true);
  };

  return (
    <div className={b()}>
      <div className={b('title')}>{locale.areYouSureYouWantToActivateCashback}</div>
      <div className={b('button')}>
        <Button text={locale.yes} callBack={handleActivate} />
      </div>
      <div className={b('button')}>
        <Button color="transparent" text={locale.no} callBack={closeFunction} />
      </div>
    </div>
  );
};

export default CashbackActivate;
